"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetFilters = resetFilters;

function resetFilters(event) {
  event.stopPropagation();
  event.preventDefault();
  window.dispatchEvent(new CustomEvent('resetFilters'));
}